import script from "./HouseList.vue?vue&type=script&setup=true&lang=js"
export * from "./HouseList.vue?vue&type=script&setup=true&lang=js"

import "./HouseList.vue?vue&type=style&index=0&id=3b198852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b198852"]])

export default __exports__